const BASKET_ACTIONS_DEBOUNCE_TIMEOUT = 1000;

export default BASKET_ACTIONS_DEBOUNCE_TIMEOUT;
